import React from "react";
import Button from "../Button";
import { IconDownload, IconPin } from "../brand/icons";

/** One newsletter issue: issue meta + summary on the left, cover on the right. */
const NewsletterCard = ({ item }) => {
  return (
    <article className="rounded-xl border border-hairline bg-surface-white p-6 transition-shadow duration-300 hover:shadow-comfort sm:p-8">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
        <div className="flex flex-col items-start lg:col-span-8">
          <div className="mb-3 flex flex-wrap items-center gap-2.5">
            <span className="rounded-md bg-cloud-mist px-3 py-1 text-label-sm font-bold uppercase tracking-wider text-spectrum-blue">
              {item.title}
            </span>
            <span className="inline-flex items-center gap-1 text-label-sm text-muted">
              <IconPin size={16} className="text-spectrum-blue" />
              {item.location}
            </span>
          </div>

          <p className="mb-1.5 font-headline text-headline-sm tracking-wide text-blue-soft">
            {`“${item.heading}”`}
          </p>

          <h2 className="mb-4 font-headline text-headline-md font-bold leading-snug text-ink">
            {item.description1}
          </h2>

          <p className="mb-6 whitespace-pre-line text-body-md leading-relaxed text-muted lg:pr-8">
            {item.description2}
          </p>

          <Button
            href={item.pdf}
            download
            target="_blank"
            rel="noopener noreferrer"
            variant="primary"
            size="sm"
            className="!px-6 !py-3"
          >
            <IconDownload size={18} />
            Download Newsletter
          </Button>
        </div>

        <div className="flex justify-center lg:col-span-4 lg:justify-end">
          <a
            href={item.pdf}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full max-w-[280px] overflow-hidden rounded-xl border border-hairline bg-mist-glow shadow-brand-sm transition-transform duration-300 hover:scale-[1.01] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-blue"
          >
            <img
              src={item.img}
              alt={`${item.title} cover`}
              loading="lazy"
              className="aspect-[3/4] w-full object-cover"
            />
          </a>
        </div>
      </div>
    </article>
  );
};

export default NewsletterCard;
